import metadata from "./ColumnsMetadata/metadata.json";
import packageJson from "../../package.json";
export var URL = process.env.REACT_APP_API_URL;
export var IA_URL = process.env.REACT_APP_IA_URL;
export var IA_LOGIN_URL = IA_URL + "/admin";
export var limits = [10, 20, 30, 50];
//While running tests, window doesn't exist as it's an object model for browser (BOM), so setting APP_URL as localhost
var _APP_URL = "";
if (typeof window == "undefined")
    _APP_URL = "https://localhost:3000";
else
    _APP_URL = window.location.protocol + "//" + window.location.host;
export var APP_URL = _APP_URL;
var metadataObj = metadata;
export var sourceColumns = metadataObj.data_sources;
export var columnCategoriesMetadata = metadataObj.active_column_categories;
export var APP_VERSION = packageJson.version;
export var GIT_VERSION = process.env.GIT_VERSION;
export var VISUALISATION_VERSION = "2.0.0";
export var DEFAULT_DATE_FIELD = "row_timestamp";
export var STORE_ACTIONS = {
    // app-slice
    APP_SET_LOADING: "app/setLoading",
    APP_SET_ERROR: "app/setError",
    APP_SET_MODE: "app/setMode",
    APP_SET_MODE_TYPE: "app/setModeType",
    APP_ADD_MODES: "app/addModes",
    APP_REMOVE_MODES: "app/removeModes",
    APP_SET_CURRENT: "app/setCurrent",
    APP_SET_PAGE: "app/setPage",
    APP_SET_QUERY_OPTIONS: "app/setQueryOptions",
    APP_SET_AGG_HEADERS: "app/setAggHeaders",
    APP_SET_FETCH_VIRTUAL: "app/setFetchVirtualColumns",
    APP_SET_VIRTUAL_META: "app/setVirtualColumnsMetadata",
    APP_SET_COLUMNS: "app/setColumns",
    APP_SET_COL_CATEGORIES: "app/setColumnCategories",
    APP_SET_RESTORE_STATE: "app/setRestoreState",
    APP_SET_VAR_FRIENDLY_COL: "app/setVariableToFriendlyColumn",
    APP_SET_DEDUPLICATE: "app/setDeduplicate",
    APP_SET_PRESETS: "app/setPresets",
    APP_SET_DATA_VIEWS: "app/setDataViews",
    APP_SET_DATA_VIEW_OPTS: "app/setDataViewQueryOptions",
    APP_SET_DEEP_LINK: "app/setDeepLinkQuery",
    APP_SET_DEEP_LINK_OPT: "app/setDeepLinkQueryOption",
    APP_SET_TAB_SWITCHING: "app/setTabSwitching",
    APP_RESET: "app/reset",
    // auth-slice
    AUTH_SET_TOKEN: "auth/setToken",
    AUTH_SET_USER: "auth/setUser",
    AUTH_SET_AUTH: "auth/setAuth",
    AUTH_SET_MARKETPLACE_ID: "auth/setMarketplaceId",
    AUTH_CLEAR: "auth/clear",
    // data-slice
    DATA_SET_TABLE: "data/setTableData",
    DATA_SET_COLUMNS: "data/setColumns",
    DATA_SET_VIEWS: "data/setViews",
    DATA_SET_SOURCE: "data/setSource",
    DATA_SET_PRESETS: "data/setPresets",
    DATA_SET_DATA_VIEWS: "data/setDataViews",
    DATA_SET_DATA_VIEW_DATA: "data/setDataViewData",
    DATA_SET_SHARED_VIEW: "data/setSharedView",
    DATA_SET_SORT_COUNT: "data/setSortCount",
    DATA_SET_VISIBLE_COLS: "data/setVisibleColumns",
    DATA_SET_VISIBLE_CATS: "data/setVisibleCategories",
    DATA_SET_CHART: "data/setChart",
    DATA_RESET: "data/reset",
    // ui-status-slice
    UI_ACTION_START: "ui/actionStart",
    UI_ACTION_SUCCESS: "ui/actionSuccess",
    UI_ACTION_ERROR: "ui/actionError",
    UI_ACTION_CLEAR: "ui/actionClear",
    UI_CLEAR_ALL_ERRORS: "ui/clearAllErrors",
};
export var ACTION_KEYS = {
    TOKEN_STATUS: "tokenStatus",
    GET_DATA_SOURCE: "getDataSource",
    GET_VIEWS: "getViews",
    GET_COLUMNS: "getColumns",
    GET_COLUMN_CATS: "getColumnCategories",
    EXPORT_CSV: "exportCsv",
    EXPORT_JSON: "exportJson",
    EXPORT_DATA_VIEW: "exportDataView",
    UPDATE_VIEW: "updateView",
    CLONE_VIEW: "cloneView",
    DELETE_VIEW: "deleteView",
    FETCH_DATA: "fetchData",
    FETCH_VIEW: "fetchView",
    FETCH_DATA_VIEW: "fetchDataView",
    SAVE_VIEW: "saveView",
    GET_PRESETS: "getPresets",
    GET_DATA_VIEWS: "getDataViews",
};
